<template>
  <div class="box">
    <!-- 试卷信息 -->
    <div class="testPaperInformationBox">
      <div class="boxTitle">试卷信息</div>
      <div class="testPaperList flex align spaceBetween">
        <div class="flex align">
          <div class="flex">
            <div class="star">*</div>
            <div class="listItemName">试卷名称:</div>
          </div>
          <div class="testPaperName-inputBox flex align">
            <input v-model="testPaperInformation.name" class="testPaperName-input" type="text" placeholder="请填写试卷名称" />
          </div>
        </div>
        <div class="flex align">
          <div class="flex">
            <div class="star">*</div>
            <div class="listItemName">试卷用途:</div>
          </div>
          <div @click="selectUsage(item.value)" v-for="(item, index) in testPaperInformation.usage" :key="index" class="radio-content flex align pointer">
            <div class="radioBox" :style="usage == item.value ? 'background: #349AFE;' : ''"></div>
            <div class="radioTxt" :style="usage == item.value ? 'color: #349AFE;' : ''">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="testPaperList flex align spaceBetween">
        <div class="flex align">
          <div class="flex">
            <div class="star">*</div>
            <div class="listItemName">查看答案时机:</div>
          </div>
          <div @click="selectSeeTheAnswerWhen(item.value)" v-for="(item, index) in testPaperInformation.seeTheAnswerWhen" :key="index" class="radio-content flex align pointer">
            <div class="radioBox" :style="seeTheAnswerWhen == item.value ? 'background: #349AFE;' : ''"></div>
            <div class="radioTxt" :style="seeTheAnswerWhen == item.value ? 'color: #349AFE;' : ''">{{ item.name }}</div>
          </div>
          <el-date-picker v-if="seeTheAnswerWhen == 'time'" v-model="testPaperInformation.seeTheAnswerTime" type="date" placeholder="选择日期"> </el-date-picker>
        </div>
        <div class="flex align">
          <div class="flex">
            <div class="star">*</div>
            <div class="listItemName">考试起止时间:</div>
          </div>
          <div class="startStopTime-box">
            <el-date-picker v-model="testPaperInformation.startStopTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </div>
      </div>
      <div class="testPaperList flex align">
        <div class="flex">
          <div class="star">*</div>
          <div class="listItemName">考试时长:</div>
        </div>
        <el-slider class="sliderBar" :marks="testPaperInformation.marks" :show-input="true" input-size="medium" :show-input-controls="false" v-model="testPaperInformation.testDuration" :step="30" show-stops :max="120"> </el-slider>
        <div class="sliderInputTxt">分钟</div>
      </div>
    </div>
    <!-- 试卷内容 -->
    <div class="testPaper-content flex column">
      <div class="flex align spaceBetween">
        <div class="boxTitle">试卷内容</div>
        <!-- <div v-if="questionBankList.length != 0" class="flex">
          <img @click="addTopic" class="addTopic pointer" src="@/assets/addTopic.png" alt="" />
          <img @click="addFromProblemLibrary" class="addFromProblemLibrary pointer" src="@/assets/addFromProblemLibrary.png" alt="" />
        </div> -->
      </div>
      <div class="gather-box flex">
        <div class="flex align">
          <div class="gather-txt">总题数:</div>
          <div class="gather-num">{{ questionBankList.length }}</div>
        </div>
        <div class="flex align" style="margin-left: 33px">
          <div class="gather-txt">总分:</div>
          <div class="gather-num">{{ totalPoints }}</div>
        </div>
      </div>
      <!-- 未添加题目 -->
      <div v-if="questionBankList.length == 0">
        <!-- 出题范围部分开始 -->
        <div class="questionScope-box">
          <div class="flex align justify">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">出题范围:</div>
            </div>
            <div class="main-content-right">
              <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover">
                <div class="selectClass-box">
                  <!-- <van-checkbox-group class="checkbox-group" v-for="(item, index) in classList" :key="index" v-model="checked">
                    <van-checkbox shape="square" @click="changeCheckbox1(item.name, item.id)" :name="item.name">课次 {{ index + 1 }} {{ item.name }}</van-checkbox>
                  </van-checkbox-group> -->
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                  <div style="margin: 15px 0"></div>
                  <el-checkbox-group v-model="checkedClassPeriod" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(item, index) in classList" :label="item" :key="item.name">课次{{ index + 1 }}{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <template @click="showPopover = true" #reference>
                  <div @click="showPopover = true" class="publicInput-box flex align spaceBetween">
                    <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择出题范围" />
                    <img @click="showPopover = true" style="margin-right: 17px" src="../../../assets/courseInformation/add.png" />
                  </div>
                </template>
              </van-popover>
            </div>
          </div>
        </div>
        <!-- 出题范围部分结束 -->
        <!-- 题目类型部分开始 -->
        <div class="questionScope-box flex justify">
          <div class="publicTop flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">题目类型:</div>
          </div>
          <div style="margin-left: 33px">
            <!-- 单选题 -->
            <div v-for="(item, index) in problemData" :key="index" class="problemData-box">
              <div class="type-box">{{ item.name }}</div>
              <div class="questionScope-box flex spaceBetween">
                <div class="publicTop flex">
                  <div class="requiredIcon">*</div>
                  <div class="informationTxt">题目数量:</div>
                </div>
                <div class="flex">
                  <div class="typeInputBox flex align">
                    <input class="typeInput" type="number" v-model="item.num" placeholder="请输入题目数量" />
                  </div>
                </div>
              </div>
              <div class="questionScope-box flex spaceBetween">
                <div class="publicTop flex">
                  <div class="requiredIcon">*</div>
                  <div class="informationTxt">每题分值:</div>
                </div>
                <div class="flex">
                  <div class="typeInputBox flex align">
                    <input class="typeInput" type="number" v-model="item.score" placeholder="请输入每道小题的分值" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 题目类型部分结束 -->
      </div>
      <!-- 习题列表部分开始 -->
      <div class="exampleListBox" v-if="questionBankList.length != 0">
        <div class="exampleList" v-for="(item, index) in questionBankList" :key="index">
          <!-- 题干 -->
          <div class="flex align spaceBetween">
            <div class="flex align">
              <div class="topicType">{{ item.types }}</div>
              <div class="questionNo">{{ index + 1 }}.</div>
              <div class="stem">{{ item.content }}</div>
            </div>
            <div class="flex align">
              <div class="score-txt">分值:</div>
              <div class="score-inputFrame flex justify">
                <input v-show="editableOrNot" v-model="item.inputValue" class="score-input" type="text" />
                <input v-show="!editableOrNot" disabled v-model="item.inputValue" class="score-input" type="text" />
              </div>
              <!-- <div v-show="editableOrNot" @click="modifyScore(item)" class="score-modify flex align justify pointer">修改分数</div>
              <div v-show="editableOrNot" @click="modifyItem(item)" class="score-modify flex align justify pointer">修改试题</div> -->
              <img v-show="editableOrNot" @click="btnDelete(index)" class="btnDelete pointer" src="@/assets/resourceManagement/btnDelete.png" />
            </div>
          </div>
          <!-- 选项 -->
          <div v-if="item.types == '单选题' || item.types == '多选题' || item.types == '判断题'" class="exampleList-option">
            <div v-for="(item, index) in item.options" :key="index">
              <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
            </div>
          </div>
          <!-- 答案 -->
          <div v-if="item.types == '单选题' || item.types == '多选题' || item.types == '判断题'" class="answer flex align">
            <div class="answer-txt">答案:</div>
            <div class="answer-English">{{ item.answer1.toString().replaceAll(",", "、") }}</div>
          </div>
          <div v-if="item.types == '填空题'" class="answer flex align">
            <div class="answer-txt">答案:</div>
            <div class="blankAnswer" v-for="(item, index) in item.options" :key="index">第{{ index + 1 }}空: {{ item }}</div>
          </div>
          <div v-if="item.types == '填空题'" class="answer flex align">
            <div v-if="index < item.options.length" class="flex align" v-for="(items, index) in item.scoreList" :key="index">
              <div class="blankAnswer">第{{ index + 1 }}空分值:</div>
              <div class="score-inputFrame flex justify">
                <input v-show="editableOrNot" v-model="items.text" class="score-input" type="text" />
                <input v-show="!editableOrNot" disabled v-model="items.text" class="score-input" type="text" />
              </div>
            </div>
          </div>
          <!-- 解析 -->
          <div class="answer flex">
            <div class="answer-txt">解析:</div>
            <div class="answer-English">{{ item.comment }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 自动按钮 -->
    <div class="flex justify" style="width: 100%; margin-bottom: 0; background: #ffffff">
      <div v-if="questionBankList.length == 0" class="btnTestpaperBox flex spaceBetween">
        <div @click="btnGenerateTestPaper" class="pushButton pointer">生成试卷</div>
        <div @click="btnCancel" class="pushButton pointer">取消</div>
      </div>
      <div v-if="questionBankList.length != 0" class="btnTestpaperBox flex spaceBetween">
        <div @click="btnUploadExam" class="pushButton pointer">保存试卷</div>
        <div @click="btnGenerateTestPaper" class="pushButton pointer">重新生成</div>
      </div>
    </div>
  </div>
</template>

<script>
import { testPaperModifyTestScores, testPaperAddition, testPaperDetails, testPaperModification, deleteTestQuestions, batchAddTestQuestions, autoGenerate } from "@/api";
import { Toast } from "vant";
export default {
  data() {
    return {
      testPaperInformation: {
        name: "", // 试卷名称
        // 用途
        usage: [
          {
            name: "平时表现",
            value: "usually",
          },
          {
            name: "期中考试",
            value: "mid",
          },
          {
            name: "期末考试",
            value: "final",
          },
          {
            name: "其他考试",
            value: "other",
          },
        ],
        // 查看答案时机
        seeTheAnswerWhen: [
          {
            name: "交卷后可查看答案",
            value: "after",
          },
          {
            name: "不可查看答案",
            value: "no",
          },
          {
            name: "自定义时间",
            value: "time",
          },
        ],
        seeTheAnswerTime: "", // 查看答案时间
        startStopTime: "", // 起止时间
        testDuration: 0, // 考试时长
        marks: {
          0: "不限时",
          30: "30",
          60: "60",
          90: "90",
          120: "120",
        },
      },
      usage: "", // 试卷用途
      questionBankList: [], // 题目列表
      editableOrNot: true, // 是否可编辑
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      totalPoints: 0, // 试卷总分
      seeTheAnswerWhen: "", // 查看答案时机
      examId: 0, // 试卷id
      showPopover: false, // 出题范围弹出框
      problemData: [
        {
          name: "单选题",
          num: "",
          score: "",
        },
        {
          name: "多选题",
          num: "",
          score: "",
        },
        {
          name: "判断题",
          num: "",
          score: "",
        },
        {
          name: "填空题",
          num: "",
          score: "",
        },
        {
          name: "简答题",
          num: "",
          score: "",
        },
      ],
      classList: [], // 课次列表
      classesList1: [], // 出题范围
      checked: [], // 自动选题=>出题范围
      checkAll: false,
      checkedClassPeriod: [], // 选择的课次
      isIndeterminate: true,
    };
  },
  created() {
    this.classList = this.$store.state.classListRecord; // 获取课次列表
    if (this.$route.params.type == "add") {
      this.$store.state.questionBankData = []; // 从试卷库页面过来清空数据
    }
    // 试卷修改进入获取内容
    if (this.$route.params.record) {
      this.examId = this.$route.params.record; // 获取修改的试卷id
      // 调用试卷修改接口
      let params = { id: this.examId };
      testPaperDetails(params).then((res) => {
        // 获取试卷名称
        this.testPaperInformation.name = res.data.datas.name;
        // 获取试卷所属用途
        this.usage = res.data.datas.usage;
        // 获取答案查看时机
        this.seeTheAnswerWhen = res.data.datas.answer_limit;
        // 获取考试时长
        this.testPaperInformation.testDuration = res.data.datas.time_total;
        // 获取查看答案时机
        this.testPaperInformation.seeTheAnswerTime = res.data.datas.answer_time;
        // 获取考试起止时间
        this.testPaperInformation.startStopTime = [res.data.datas.time_begin, res.data.datas.time_end];
        // 获取试题列表
        let publicRes = res.data.datas.exam_items;
        for (let i = 0; i < publicRes.length; i++) {
          publicRes[i].exam_item.linkScore = publicRes[i].score; // 获取试题的link分数
          publicRes[i].exam_item.inputValue = publicRes[i].exam_item.linkScore;
          publicRes[i].exam_item.examId = publicRes[i].exam_id; // 获取试卷id
          publicRes[i].exam_item.examItemId = publicRes[i].exam_item_id; // 获取试题id
          this.questionBankList.push(publicRes[i].exam_item);
        }
        if (this.$store.state.questionBankData.length != 0) {
          this.$store.state.questionBankData.forEach((publicRes) => {
            // 提取分数并转换为数字
            const scoreValue = parseFloat(publicRes.score.replace(/分/g, ""));
            // 更新对象属性
            publicRes.linkScore = scoreValue;
            publicRes.inputValue = scoreValue;
          });
          // 获取题目列表
          this.questionBankList = this.questionBankList.concat(this.$store.state.questionBankData);
        }
        if (this.$route.params.topicData) {
          // 提取分数并转换为数字
          const scoreValue = parseFloat(this.$route.params.topicData.score.replace(/分/g, ""));
          // 更新对象属性
          this.$route.params.topicData.linkScore = scoreValue;
          this.$route.params.topicData.inputValue = scoreValue;
          this.questionBankList.push(this.$route.params.topicData); // 从添加题目页面获取的数据
        }
        // 数据转换:获取的数据
        for (let i = 0; i < this.questionBankList.length; i++) {
          this.totalPoints += this.questionBankList[i].linkScore; // 题目总分计算
          this.questionBankList[i].answer1 = [];
          for (let j = 0; j < this.questionBankList[i].answer.length; j++) {
            this.questionBankList[i].answer1[j] = this.optionOrder[this.questionBankList[i].answer[j]]; // 题目答案获取
          }
          this.questionBankList[i].content = this.questionBankList[i].content.replace(/<[^>]+>/g, ""); // 题目题干获取
          this.questionBankList[i].comment = this.questionBankList[i].comment.replace(/<[^>]+>/g, ""); // 题目解析获取
          if (this.questionBankList[i].types == "single") {
            this.questionBankList[i].types = "单选题";
          } else if (this.questionBankList[i].types == "multi") {
            this.questionBankList[i].types = "多选题";
          } else if (this.questionBankList[i].types == "truefalse") {
            this.questionBankList[i].types = "判断题";
            this.questionBankList[i].options[0] = "正确";
            this.questionBankList[i].options[1] = "错误";
          } else if (this.questionBankList[i].types == "answer") {
            this.questionBankList[i].types = "简答题";
          } else if (this.questionBankList[i].types == "blank") {
            this.questionBankList[i].types = "填空题";
          }
        }
      });
    } else {
      if (this.$store.state.questionBankData.length != 0) {
        // 获取题目列表
        this.questionBankList = this.$store.state.questionBankData;
        // 获取试卷信息
        let examinationMessage = this.$store.state.examinationMessage;
        // 获取试卷名称
        this.testPaperInformation.name = examinationMessage.name;
        // 获取试卷所属用途
        this.usage = examinationMessage.usage;
        // 获取答案查看时机
        this.seeTheAnswerWhen = examinationMessage.seeTheAnswerWhen;
        // 获取考试时长
        this.testPaperInformation.testDuration = examinationMessage.testDuration;
        // 获取查看答案时机
        this.testPaperInformation.seeTheAnswerTime = examinationMessage.seeTheAnswerTime;
        // 获取考试起止时间
        this.testPaperInformation.startStopTime = [examinationMessage.startStopTime[0], examinationMessage.startStopTime[1]];
      }
      if (this.$route.params.topicData) this.questionBankList.push(this.$route.params.topicData); // 从添加题目页面获取的数据
      console.log(this.questionBankList);
      for (let i = 0; i < this.questionBankList.length; i++) {
        this.questionBankList[i].content = this.questionBankList[i].content.replace(/<[^>]+>/g, ""); // 题目题干获取
        this.questionBankList[i].comment = this.questionBankList[i].comment.replace(/<[^>]+>/g, ""); // 题目解析获取
        this.questionBankList[i].score = this.questionBankList[i].score; // 题目分值获取
        this.questionBankList[i].inputValue = this.questionBankList[i].score; // 题目分值获取
        this.totalPoints += parseFloat(this.questionBankList[i].score); // 题目总分计算
        this.questionBankList[i].answer1 = this.questionBankList[i].answer;
        for (let j = 0; j < this.questionBankList[i].answer1.length; j++) {
          if (!isNaN(this.questionBankList[i].answer1[j])) {
            this.questionBankList[i].answer1[j] = this.optionOrder[this.questionBankList[i].answer1[j]]; // 题目答案获取
          }
        }
        if (this.questionBankList[i].types == "single") {
          this.questionBankList[i].types = "单选题";
        } else if (this.questionBankList[i].types == "multi") {
          this.questionBankList[i].types = "多选题";
        } else if (this.questionBankList[i].types == "truefalse") {
          this.questionBankList[i].types = "判断题";
          this.questionBankList[i].options[0] = "正确";
          this.questionBankList[i].options[1] = "错误";
        } else if (this.questionBankList[i].types == "answer") {
          this.questionBankList[i].types = "简答题";
        } else if (this.questionBankList[i].types == "blank") {
          this.questionBankList[i].types = "填空题";
        }
      }
    }
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedClassPeriod = val ? this.classList : [];
      this.isIndeterminate = false;
      this.checked = this.checkedClassPeriod
        .map((item) => item.name)
        .filter((name) => name != null) // 过滤 null/undefined
        .join(",");
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.classList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.classList.length;
      console.log(this.checkedClassPeriod);
      this.checked = this.checkedClassPeriod
        .map((item) => item.name)
        .filter((name) => name != null) // 过滤 null/undefined
        .join(",");
    },
    // 生成试卷
    btnGenerateTestPaper() {
      if (this.checkedClassPeriod.length == 0) {
        Toast("请选择出题范围！");
        return;
      } else {
        // 出题范围
        let lesson_item_ids = this.checkedClassPeriod
          .map((item) => item.id)
          .filter((id) => id != null) // 过滤 null/undefined
          .join(",");
        // 调用试卷自动生成接口
        let data = {
          lesson_item_ids: lesson_item_ids,
          num_single: this.problemData[0].num,
          num_multi: this.problemData[1].num,
          num_truefalse: this.problemData[2].num,
          num_blank: this.problemData[3].num,
          num_answer: this.problemData[4].num,
          score_single: this.problemData[0].score,
          score_multi: this.problemData[1].score,
          score_truefalse: this.problemData[2].score,
          score_blank: this.problemData[3].score,
          score_answer: this.problemData[4].score,
        };
        autoGenerate(data).then((res) => {
          if (res.data.code == 0) {
            Toast("生成成功！");
            this.totalPoints = 0;
            let questionBankList = res.data.datas;
            for (let i = 0; i < questionBankList.length; i++) {
              questionBankList[i].content = questionBankList[i].content.replace(/<[^>]+>/g, ""); // 题目题干获取
              questionBankList[i].comment = questionBankList[i].comment.replace(/<[^>]+>/g, ""); // 题目解析获取
              questionBankList[i].answer1 = questionBankList[i].answer;
              for (let j = 0; j < questionBankList[i].answer1.length; j++) {
                questionBankList[i].answer1[j] = this.optionOrder[questionBankList[i].answer1[j]]; // 题目答案获取
              }
              if (questionBankList[i].types == "single") {
                questionBankList[i].types = "单选题";
                questionBankList[i].inputValue = this.problemData[0].score;
              } else if (questionBankList[i].types == "multi") {
                questionBankList[i].types = "多选题";
                questionBankList[i].inputValue = this.problemData[1].score;
              } else if (questionBankList[i].types == "truefalse") {
                questionBankList[i].types = "判断题";
                questionBankList[i].options[0] = "正确";
                questionBankList[i].options[1] = "错误";
                questionBankList[i].inputValue = this.problemData[2].score;
              } else if (questionBankList[i].types == "answer") {
                questionBankList[i].types = "简答题";
                questionBankList[i].inputValue = this.problemData[4].score;
              } else if (questionBankList[i].types == "blank") {
                questionBankList[i].types = "填空题";
                questionBankList[i].scoreList = questionBankList[i].scores?.map((item) => {
                  return { text: item };
                });
                questionBankList[i].inputValue = this.problemData[3].score;
              }
              this.totalPoints += parseFloat(questionBankList[i].inputValue); // 题目总分计算
            }
            // 定义排序优先级
            const sortOrder = ["单选题", "多选题", "判断题", "填空题", "简答题"];
            questionBankList.sort((a, b) => {
              return sortOrder.indexOf(a.types) - sortOrder.indexOf(b.types);
            });
            this.questionBankList = questionBankList; // 获取题目列表
          }
        });
      }
    },
    // 出题范围
    changeCheckbox1(classIdx, idx) {
      if (this.classesList1.indexOf(idx) > -1) {
        this.classesList1.splice(this.classesList1.indexOf(idx), 1);
      } else {
        this.classesList1.push(idx);
      }
    },
    // 选择用途
    selectUsage(usage) {
      this.usage = usage;
    },
    // 选择查看答案时机
    selectSeeTheAnswerWhen(type) {
      this.seeTheAnswerWhen = type;
    },
    // 添加题目
    addTopic() {
      // 添加
      this.$router.push({
        name: "addExercises",
        params: { comeFrom: "automaticTestComposition" },
      });
      this.testPaperInformation.usage = this.usage;
      this.testPaperInformation.seeTheAnswerWhen = this.seeTheAnswerWhen;
      this.$store.commit("GET_examinationMessage", this.testPaperInformation); // 储存试卷信息
      this.$store.commit("GET_questionBankData", this.questionBankList); // 储存题目列表到store
    },
    // 从习题库添加
    addFromProblemLibrary() {
      if (this.examId) {
        // 修改
        this.$router.push({
          name: "addFromProblemLibrary",
          params: { comeFrom: "testPaperComposition", record: this.examId },
        });
      } else {
        // 添加
        this.$router.push({
          name: "addFromProblemLibrary",
          params: { comeFrom: "testPaperComposition" },
        });
      }
      this.testPaperInformation.usage = this.usage;
      this.testPaperInformation.seeTheAnswerWhen = this.seeTheAnswerWhen;
      this.$store.commit("GET_examinationMessage", this.testPaperInformation); // 储存试卷信息
    },
    // 修改试卷习题分数
    modifyScore(questionsData) {
      // 调用试卷试题修改接口
      let data = { exam_id: questionsData.examId, exam_item_id: questionsData.examItemId, score: questionsData.inputValue };
      testPaperModifyTestScores(data).then((res) => {
        if (res.data.code == 0) {
          Toast("修改成功！");
        }
      });
    },
    // 修改习题
    modifyItem(questionsData) {
      this.$router.push({
        name: "addExercises",
        params: { record: questionsData, examId: this.examId },
      });
    },
    // 删除题目
    btnDelete(idx) {
      if (this.examId) {
        // 修改试卷时从数据库删除试题
        let data = { exam_id: this.examId, exam_item_id: this.questionBankList[idx].id };
        deleteTestQuestions(data).then((res) => {
          this.totalPoints -= this.questionBankList[idx].score;
          this.questionBankList.splice(idx, 1);
        });
      } else {
        // 手动选题时从试题列表删除试题
        this.totalPoints -= this.questionBankList[idx].inputValue;
        this.questionBankList.splice(idx, 1);
        this.$store.commit("GET_questionBankData", this.questionBankList); // 储存题目列表到store
      }
    },
    // 上传试卷
    btnUploadExam() {
      let score = 0;
      for (let i in this.questionBankList) {
        score += Number(this.questionBankList[i].inputValue);
      }
      if (this.testPaperInformation.name == "") {
        Toast("请输入试卷名称！");
      } else if (this.usage == "") {
        Toast("请选择试卷用途！");
      } else if (this.seeTheAnswerWhen == "") {
        Toast("请选择查看答案时机！");
      } else if (this.seeTheAnswerWhen == "time" && this.testPaperInformation.seeTheAnswerTime == "") {
        Toast("请选择查看答案时间！");
      } else if (this.testPaperInformation.startStopTime == "") {
        Toast("请选择考试起止时间！");
      } else if (this.questionBankList.length == 0) {
        Toast("请添加题目！");
      } else {
        let exampleID = this.questionBankList.map((item) => item.id).join(",");
        let exampleScore = this.questionBankList
          .map((item) => {
            if (item.types === "填空题") {
              return item.scoreList?.map((s) => s.text).join("|"); // 填空题用 | 拼接
            } else {
              return item.inputValue.toString(); // 其他情况直接取 score
            }
          })
          .join(","); // 最终用逗号拼接所有结果
        const beginDate = new Date(this.testPaperInformation.startStopTime[0]);
        const beginYear = beginDate.getFullYear();
        const beginMonth = String(beginDate.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
        const beginDay = String(beginDate.getDate()).padStart(2, "0");
        const beginFormattedDate = `${beginYear}-${beginMonth}-${beginDay} 00:00:00`; // 获取考试开始时间
        const endDate = new Date(this.testPaperInformation.startStopTime[1]);
        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
        const endDay = String(endDate.getDate()).padStart(2, "0");
        const endFormattedDate = `${endYear}-${endMonth}-${endDay} 23:59:59`; // 获取考试开始时间
        if (!this.examId) {
          // 调用试卷添加接口
          let params = {
            score: score,
            name: this.testPaperInformation.name,
            types: "auto",
            exam_item_ids: exampleID,
            exam_item_scores: exampleScore,
            lesson_id: this.$store.state.courseDetails.id,
            usage: this.usage,
            category: "exam",
            answer_limit: this.seeTheAnswerWhen,
            time_begin: beginFormattedDate,
            time_end: endFormattedDate,
            time_total: this.testPaperInformation.testDuration,
          };
          if (this.seeTheAnswerWhen == "time") {
            const date = new Date(this.testPaperInformation.seeTheAnswerTime);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
            const day = String(date.getDate()).padStart(2, "0");
            const formattedDate = `${year}-${month}-${day} 00:00:00`;
            params.answer_time = formattedDate;
          }
          testPaperAddition(params).then((res) => {
            if (res.data.code == 0) {
              Toast("上传成功");
              this.$router.push({
                name: "onlineExamination",
              });
            }
          });
        } else {
          // 调用试卷修改接口
          let data = {
            score: score,
            name: this.testPaperInformation.name,
            id: this.examId,
            usage: this.usage,
            category: "exam",
            answer_limit: this.seeTheAnswerWhen,
            time_begin: beginFormattedDate,
            time_end: endFormattedDate,
            time_total: this.testPaperInformation.testDuration,
          };
          testPaperModification(data).then((res) => {
            if (res.data.code == 0) {
              let data = { exam_id: this.examId, exam_item_ids: exampleID, scores: exampleScore };
              batchAddTestQuestions(data).then((res) => {
                if (res.data.code == 0) {
                  Toast("修改成功！");
                  this.$router.push({
                    name: "onlineExamination",
                  });
                }
              });
            }
          });
        }
      }
    },
    // 取消按钮
    btnCancel() {
      this.$router.push({
        name: "onlineExamination",
      });
    },
  },
};
</script>

<style src="./index.css" scoped></style>
